import { PopulationDNDGrid } from '../shared/interfaces';
import { TEST_CHOICE_TYPES } from './choice-types';
import { TestAssociatedSuccessCriteria } from './test-associated-success-criteria.enum';

export const dndGridMatch: {
  [key: string]: PopulationDNDGrid;
} = {
  [TEST_CHOICE_TYPES.TEST_R_DND_GRID_MATCH_2X6X4]: {
    question: {
      text: 'The word {TARGET_TEXT} has 4 sounds. Drag the letters that represent the sounds.',
    },
    gridConfig: {
      rows: 2,
      columns: 6,
    },
    labels: [{ text: '' }],
    answerChoices: [
      {
        id: 'sound-1-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
      {
        id: 'sound-2-e',
        choice: {
          texts: [
            {
              text: 'e',
            },
          ],
        },
      },
      {
        id: 'sound-3-s',
        choice: {
          texts: [
            {
              text: 's',
            },
          ],
        },
      },
      {
        id: 'sound-4-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
      {
        id: 'sound-5-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
    ],
    answers: ['sound-1-t', 'sound-2-e', 'sound-3-s', 'sound-4-t'],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.DRAG_AND_DROP],
  },
  [TEST_CHOICE_TYPES.TEST_R_DND_GRID_MATCH_1X5X3]: {
    question: {
      text: 'The word {TARGET_TEXT} has 3 sounds. Drag the letters that represent the sounds.',
    },
    gridConfig: {
      rows: 1,
      columns: 5,
    },
    labels: [{ text: '' }],
    answerChoices: [
      {
        id: 'sound-1-th',
        choice: {
          texts: [
            {
              text: 'th',
            },
          ],
        },
      },
      {
        id: 'sound-2-ough',
        choice: {
          texts: [
            {
              text: 'ough',
            },
          ],
        },
      },
      {
        id: 'sound-3-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
      {
        id: 'sound-4-aw',
        choice: {
          texts: [
            {
              text: 'aw',
            },
          ],
        },
      },
      {
        id: 'sound-5-au',
        choice: {
          texts: [
            {
              text: 'au',
            },
          ],
        },
      },
    ],
    answers: ['sound-1-th', 'sound-2-ough', 'sound-3-t'],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.DRAG_AND_DROP],
  },
  [TEST_CHOICE_TYPES.TEST_R_DND_GRID_MATCH_2X5X10]: {
    question: {
      text: 'The word {TARGET_TEXT} has 10 sounds. Drag the letters that represent the sounds.',
    },
    gridConfig: {
      rows: 2,
      columns: 5,
    },
    labels: [{ text: '' }],
    answerChoices: [
      {
        id: 'sound-1-i',
        choice: {
          texts: [
            {
              text: 'i',
            },
          ],
        },
      },
      {
        id: 'sound-2-n',
        choice: {
          texts: [
            {
              text: 'n',
            },
          ],
        },
      },
      {
        id: 'sound-3-s',
        choice: {
          texts: [
            {
              text: 's',
            },
          ],
        },
      },
      {
        id: 'sound-4-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
      {
        id: 'sound-5-r',
        choice: {
          texts: [
            {
              text: 'r',
            },
          ],
        },
      },
      {
        id: 'sound-6-uh',
        choice: {
          texts: [
            {
              text: 'u',
            },
          ],
        },
      },
      {
        id: 'sound-7-m',
        choice: {
          texts: [
            {
              text: 'm',
            },
          ],
        },
      },
      {
        id: 'sound-8-eh',
        choice: {
          texts: [
            {
              text: 'e',
            },
          ],
        },
      },
      {
        id: 'sound-9-n',
        choice: {
          texts: [
            {
              text: 'n',
            },
          ],
        },
      },
      {
        id: 'sound-10-t',
        choice: {
          texts: [
            {
              text: 't',
            },
          ],
        },
      },
    ],
    answers: [
      'sound-1-i',
      'sound-2-n',
      'sound-3-s',
      'sound-4-t',
      'sound-5-r',
      'sound-6-uh',
      'sound-7-m',
      'sound-8-eh',
      'sound-9-n',
      'sound-10-t',
    ],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.DRAG_AND_DROP],
  },
};
